import React from 'react';

interface ProgressTaskBarProps {
  completed: number;
  total: number;
  title: string;
  icon: React.ReactNode;
}

function ProgressTaskBar({completed, total, title, icon}: ProgressTaskBarProps) {
  const progressPercentage = (completed / total) * 100;

  return (
    <div className="flex flex-col w-full">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-4">
          {icon && <span className="flex items-center mr-2">{icon}</span>}
          <span className="font-medium text-[#333] text-kiosko-s">{title}</span>
        </div>
        <div className="font-medium text-[#333] text-kiosko-s">
          {completed}/{total}
        </div>
      </div>
      <div className="w-full h-3 bg-[#e0e0e0] rounded-sm overflow-hidden">
        <div
          className="h-full bg-[#4f46e5] rounded-[12px] transition-width duration-300"
          style={{width: `${progressPercentage}%`}}
        />
      </div>
    </div>
  );
}

export {ProgressTaskBar};
